import { Snapshot } from '@ember-data/store';
import pick from 'lodash-es/pick';
import { underscore } from '@ember/string';
import ApplicationSerializer from 'uplisting-frontend/serializers/application';

export default class AirbnbOfficialListingSerializer extends ApplicationSerializer {
  serialize(snapshot: Snapshot, options: object) {
    const data = super.serialize(snapshot, options);

    if (!snapshot.id) {
      return data;
    }

    const changed = Object.keys(snapshot.changedAttributes()).map((key) =>
      underscore(key),
    );

    // @ts-expect-error - we have no typings for the json api
    data.data.attributes = pick(data.data.attributes, changed);
    // @ts-expect-error - we have no typings for the json api
    delete data.data.relationships;

    return data;
  }
}

declare module 'ember-data/types/registries/serializer' {
  interface SerializerRegistry {
    'airbnb-official-listing': AirbnbOfficialListingSerializer;
  }
}
